export default __webpack_public_path__ + "static/media/img.e264d66b.jpg";